module.exports = __webpack_public_path__ + "static/media/lab.bff32e1f.jpg";